import { stringify } from '../../../../core/utils/query-string'
import {
  CityData,
  PaginatedData,
  ProvinceData,
  QueryParams,
  RequestOptions,
} from '../../../../types/interfaces'
import { client } from '../../client'

export class ProvincesService {
  async getProvinceById(provinceId: number) {
    return client.get<ProvinceData>(`/provinces/${provinceId}`)
  }

  async getProvinceCitiesById(provinceId: number) {
    return client.get<PaginatedData<CityData[]>>(
      `/provinces/${provinceId}/cities`
    )
  }

  async getProvinces(filters?: QueryParams, options?: RequestOptions) {
    return client.get<PaginatedData<ProvinceData[]>>(
      `/provinces?${filters ? stringify(filters) : ''}`,
      options
    )
  }
}
